<template>
    <div>
        <div style="min-height: 80vh">
            <slot />
        </div>
        <!--<CookieBanner />-->
    </div>
</template>

<script>
    //import CookieBanner from "./components/cookie.vue";

    export default {
        name: 'FramelessLayout',

        data() {
            return {
            }
        },

        components: {
            //CookieBanner
        }
    };
</script>